import { Injectable, Injector, NgZone } from '@angular/core';
import { EditTemplateMenuViewModel } from '../edit-template-menu-view-model';
import { TemplateDomainModel } from '../../../../../domainModels/template-domain-model';
import { LocationDomainModel } from '../../../../../domainModels/location-domain-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditProductMenuViewModel } from '../../../../menu/viewModels/edit-product-menu-view-model';
import { WebSocketService } from '../../../../../services/web-socket.service';
import { ToastService } from '../../../../../modules/toasts/service/toast.service';

@Injectable()
export abstract class EditTemplateShelfTalkerMenuViewModel extends EditTemplateMenuViewModel {
  protected constructor(
    protected override editMenuViewModel: EditProductMenuViewModel,
    templateDomainModel: TemplateDomainModel,
    locationDomainModel: LocationDomainModel,
    toastService: ToastService,
    webSocketService: WebSocketService,
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector
  ) {
    super(
      editMenuViewModel,
      templateDomainModel,
      locationDomainModel,
      toastService,
      webSocketService,
      ngZone,
      ngbModal,
      injector
    );
  }
}
